<script module lang="ts">
  export interface PageStoryblokProps {
    blok: { body: any[] };
  }
</script>

<script lang="ts">
  import { storyblokEditable, StoryblokComponent } from "@storyblok/svelte";

  const { blok }: PageStoryblokProps = $props();
</script>

{#key blok}
  <div use:storyblokEditable={blok}>
    {#each blok.body as b}
      <StoryblokComponent blok={b} />
    {/each}
  </div>
{/key}
